import { updatesData } from '@/mocks/homeData';

export default function UpdatesSection() {
  return (
    <section id="updates" className="w-full py-12 md:py-16 lg:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="mb-8 md:mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-secondary-100 text-secondary-900 text-xs md:text-sm font-medium mb-3">
            <i className="ri-time-line"></i>
            <span>每日更新</span>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-3">
            最新更新动态
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl">
            实时追踪韩漫、日漫、国漫的最新连载动态，不错过任何一章精彩剧情
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4 max-w-5xl mx-auto">
          {updatesData.map((item, idx) => (
            <div
              key={idx}
              className="flex items-start gap-3 p-3 md:p-4 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all group"
            >
              <div className="shrink-0 w-16 md:w-20 text-center">
                <div className="text-xs md:text-sm font-semibold text-primary-600">{item.date.split('.')[1]}.{item.date.split('.')[2]}</div>
                <div className="text-xs text-foreground-500">{item.date.split('.')[0]}</div>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-1 line-clamp-1 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <div className="flex items-center gap-2 flex-wrap">
                  <span className={`text-xs px-2 py-0.5 rounded font-medium
                    ${item.tag === '韩漫' ? 'bg-accent-100 text-accent-900' :
                      item.tag === '日漫' ? 'bg-primary-100 text-primary-700' :
                      'bg-secondary-100 text-secondary-700'}`}>
                    {item.tag}
                  </span>
                  <span className="text-xs text-foreground-500">{item.type}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}